/**
 * Model for BadPress Match response.
 *
 * @author jagpreet.singh@vernuso.com (Jagpreet Singh)
 */
export class BadPressMatchResponse {
    suggestionList: Array<BadPressMatchRecord>;
    date: string;
}

export class BadPressMatchRecord {
    badPressEntity: BadPressEntity;
    relationEntityId: number;
    matchResolution: number;
    falseMatchReason: number;
    comments: string;
    date: Date;
}

export class BadPressEntity {
    id: string;
    name: string;
    address: string;
    countryCodes: string;
    countries: string;
    status: string;
    recordType: string;
    jsonData: string;
    source: string;
    /** Present on NEWS (adverse media) rows from BadPressNewsEntityVO. */
    title?: string;
    url?: string;
    description?: string;
    provider_name?: string;
    category?: string;
    published_date?: any;
    keywords?: string;
    emotionScore?: number;
    emotionMagnitude?: number;
    emotionType?: string;
}

export enum BadPressMatchResolution {
    PROBABLE = <any>'PROBABLE',
    TRUE = <any>'TRUE',
    FALSE = <any>'FALSE',
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/badpress-match.model.ts